import React from 'react';
import { motion } from 'framer-motion';
import { ShoppingCartIcon } from 'lucide-react';
interface CTAButtonProps {
  text?: string;
  className?: string;
}
export function CTAButton({
  text = 'QUIERO ORDENAR MI ESTUDIO HOY',
  className = ''
}: CTAButtonProps) {
  return <motion.a href="https://checkout.abastecedordigital.shop/cart/51749378916672:1" className={`inline-flex items-center justify-center gap-3 bg-gold text-[#0a1628] font-bold text-lg md:text-xl py-4 px-8 rounded-lg shadow-[0_0_20px_rgba(201,168,76,0.4)] hover:shadow-[0_0_30px_rgba(201,168,76,0.6)] transition-shadow duration-300 ${className}`} whileHover={{
    scale: 1.05
  }} whileTap={{
    scale: 0.95
  }} initial={{
    opacity: 0,
    y: 20
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true
  }} data-id="element-33">
      <ShoppingCartIcon className="w-6 h-6" data-id="element-34" />
      <span className="text-center" data-id="element-35">{text}</span>
    </motion.a>;
}